import { gql } from '@apollo/client';
import { EMAIL_TEMPLATE_FIELDS } from './EmailTemplate.fragment';
import { SITE_FIELDS } from './Site.fragment';

export const DAILY_DIGEST_FIELDS = gql`
  ${SITE_FIELDS}
  ${EMAIL_TEMPLATE_FIELDS}
  fragment DailyDigestFields on emailDailyDigest {
    id
    city
    charityEvent
    charityOrganizations
    dateCreated
    dateUpdated
    newsItems
    newsLinks
    series1
    series2
    series3
    series4
    series5
    series6
    series7
    series8
    series9
    series10
    property
    emailTemplateId
    mailchimpCampaignId
    sendDate
    sendTime
    siteId
    isSent
    isScheduled
    style
    subject
    site {
      ...SiteFields
    }
    emailTemplate {
      ...EmailTemplateFields
    }
  }
`;
